'use client'
import { useComponentTranslation } from '@core/i18n'
import { Icon, Tag } from '@core/ui-elements'
import { FC } from 'react'
import { AiFillFlag } from 'react-icons/ai'
import { IoIosWarning } from 'react-icons/io'
import { MdCircle } from 'react-icons/md'

import { CounterTag } from '../counter-tag'

export interface IPickingAmountTags {
  scannedAmount?: number
  manuallyAmount?: number
  flaggedAmount?: number
  amount: number
  isCompleted?: boolean
  isCurrentProduct?: boolean
  size?: 'xs' | 'sm' | 'md' | 'lg'
  amountWithColor?: boolean
  unavailableProduct?: boolean
}

export const PickingAmountTags: FC<IPickingAmountTags> = ({
  scannedAmount,
  manuallyAmount,
  flaggedAmount,
  amount,
  isCompleted = false,
  unavailableProduct = false,
  isCurrentProduct = false,
  size = 'sm',
  amountWithColor = false,
}) => {
  const t = useComponentTranslation('PickingAmountTags')

  if (unavailableProduct && !flaggedAmount) {
    return (
      <Tag backgroundColor={'white'} size={size}>
        <Icon
          as={IoIosWarning}
          boxSize={'1rem'}
          color={'red.500'}
          marginRight={'0.25rem'}
        />
        {t('product unavailable')}
      </Tag>
    )
  }

  if (!scannedAmount && !manuallyAmount && !flaggedAmount)
    return (
      <Tag backgroundColor={'white'} size={size}>
        {isCurrentProduct ? (
          <>
            <Icon
              as={MdCircle}
              boxSize={'0.5rem'}
              color={'yellow.500'}
              marginRight={'0.25rem'}
            />
            {t('Collection in progress')}
          </>
        ) : (
          t('itemsToPick', { count: amount })
        )}
      </Tag>
    )

  return (
    <>
      {!!scannedAmount && (
        <CounterTag
          amount={scannedAmount}
          amountWithColor={amountWithColor}
          color={isCompleted ? 'green.500' : 'red.500'}
          icon={MdCircle}
          label={t('scanned', { count: amount })}
          size={size}
          total={amount}
        />
      )}
      {!!manuallyAmount && (
        <CounterTag
          amount={manuallyAmount}
          amountWithColor={amountWithColor}
          color={isCompleted ? 'blue.500' : 'red.500'}
          icon={MdCircle}
          label={t('manual')}
          size={size}
          total={amount}
        />
      )}
      {!!flaggedAmount && (
        <CounterTag
          amount={flaggedAmount}
          amountWithColor={amountWithColor}
          color={'red.500'}
          icon={AiFillFlag}
          label={t('flagged', { count: amount })}
          size={size}
          total={amount}
        />
      )}
    </>
  )
}
